import { render } from "./RegisterPaymentServicesDGII.vue?vue&type=template&id=fe202a80"
import script from "./RegisterPaymentServicesDGII.vue?vue&type=script&lang=js"
export * from "./RegisterPaymentServicesDGII.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__